import Link from 'next/link';
import clsx from 'clsx';

import Image from '@components/elements/Image';
import MessageCounterTag from '@components/elements/card/MessageCounterTag';
import Tag from '@components/elements/card/Tag';

import styles from './AiGirlCard.module.css';

const AiGirlCard = ({
  girlName,
  img,
  description,
  linkToChat,
  msgCounterValue,
  tags = [],
}) => {
  return (
    <Link
      href={linkToChat}
      className={clsx(
        styles.card,
        'block max-w-sm overflow-hidden bg-[#151719]',
        'border border-[#2B6EFF] rounded-xl',
        'transform transition duration-300',
        'hover:delay-200 hover:scale-105',
        'focus:scale-105',
      )}
      locale="en"
      prefetch={false}
    >
      <div className="relative">
        <img
          src={img}
          alt="ai girl card preview"
          width={700}
          height={700}
          className="rounded-b-xl"
        />

        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-0% to-50% from-black to-black/0" />

        <MessageCounterTag
          value={msgCounterValue}
          className="absolute top-3 left-3"
        />
      </div>

      <div className="p-[16px] pb-[28px] flex flex-col gap-2">
        <h3 className="text-[18px] leading-[20px] font-semibold text-white m-0">
          {girlName}
        </h3>

        <div className="flex flex-row items-center flex-wrap gap-2">
          {tags.map((tag) => (
            <Tag key={tag.id} id={tag.id} name={tag.label} />
          ))}
        </div>

        <p className="text-[14px] leading-normal font-normal text-white/80 m-0">
          {description}
        </p>
      </div>
    </Link>
  );
};
export default AiGirlCard;
